import { IStoreDocument } from '../store/IStoreDocument';

export interface IEventMarker extends IStoreDocument {
	participantContactIds?: string[];
	authorId: string;
}